import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { subkundenRoutes } from './subkunden.routes';
import { SOFTLINE_PERMISSIONS_SUBKUNDEN } from './subkunden.shared';

export const subkundenProviders: Array<Provider | EnvironmentProviders> = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'subkunden',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#SUBKUNDEN.TITLE',
      icon: 'fa-regular fa-house-chimney-user',
      route: '/subkunden',
      permission: SOFTLINE_PERMISSIONS_SUBKUNDEN,
      group: getModuleGroupByName('Gewerbe'),
    });
  }),
];

export function provideSubkundenModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'wws/subkunden',
        title: '#SUBKUNDEN.TITLE',
        icon: 'fa-regular fa-house-chimney-user',
        route: '/subkunden',
        permission: SOFTLINE_PERMISSIONS_SUBKUNDEN,
        group: getModuleGroupByName('Gewerbe'),
      },
      withSoftAppsModuleRoutes({ app: subkundenRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/wws/subkunden',
        description: 'Subkunden verwalten.',
      })
    ),
  ];
}
